<template>
<v-container fluid>
    <v-layout row>
        <v-flex xs2>
        <v-card v-show="showQuery" height="700px" class="scroll-y">
            <v-toolbar flat color="white">
                <v-toolbar-title style="width:100%">
                    <v-text-field label="关键字" v-model="keyword" @change="query" />
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="query">
                    <v-icon>search</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider />
            <v-progress-linear :indeterminate="isQuery" height="3" :style="isQuery?'visibility:visible':'visibility:hidden'" />
            <v-list two-line>
                <v-list-tile v-for="item in dataSource.items" :key="item.Id" :style="item.Id===model.Id?'background:#E0E0E0;':''">
                <v-list-tile-content>
                    <v-list-tile-title v-text="item.Name"></v-list-tile-title>
                    <v-list-tile-sub-title>
                        {{item.Cd}}
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon small color="primary" dark v-on="on" @click="onCopy(item.Id)">mdi-content-copy</v-icon>
                            </template>
                            <span>复制主键</span>
                        </v-tooltip>
                    </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-avatar>
                    <v-btn icon @click="queryCode(item.Id)">
                        <v-icon>edit</v-icon>
                    </v-btn>
                </v-list-tile-avatar>
                </v-list-tile>
            </v-list>
        </v-card>
        </v-flex>
        <v-flex xs10>
        <v-layout column style="height:800px;margin-left:10px">
            <v-toolbar color="primary" dark flat>
                <v-toolbar-side-icon></v-toolbar-side-icon>
                <v-toolbar-title class="white--text">{{model.Name}}</v-toolbar-title>
                <v-spacer></v-spacer>                
                <label style="color:yellow;font-size:16px;font-weight:bold;margin-right:30px">{{message}}</label>
                <v-btn icon @click="save">
                    <v-icon>save</v-icon>
                </v-btn>
                <v-btn icon @click="refresh">
                    <v-icon>refresh</v-icon>
                </v-btn>
                <el-switch v-model="editMode" class="inline" active-text="预览" inactive-text="编辑" active-color="green" inactive-color="#3C3C3C" />
            </v-toolbar>
            <v-progress-linear :indeterminate="isEdit" height="3" :style="isEdit?'visibility:visible;margin-top:0px;margin-bottom:0px':'visibility:hidden;margin-top:0px;margin-bottom:0px'" />
            <v-tabs slider-color="primary" style="width:100%" v-show="!editMode">
            <v-tab key="前台代码" ripple>
              前台代码
            </v-tab>
            <v-tab key="后台代码" ripple>
              后台代码
            </v-tab>
            <v-tabs-items v-model="codeSelectedTable">
              <v-tab-item key="前台代码">
                  <v-tabs>
                      <v-tab>template模板</v-tab>
                      <v-tab-item>
                          <gh-code-editor :height="600" ref="codePage" title="模板编译" :show-actions="false" v-model="currentItem.template"
                          :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'html'}">
                            <template #title>
                                <div></div>
                            </template>
                           </gh-code-editor>
                      </v-tab-item>
                      <v-tab>js代码</v-tab>
                      <v-tab-item>
                          <gh-code-editor :height="600" ref="codePage" title="脚本编译" :show-actions="false" v-model="currentItem.js"
                          :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'javascript'}">
                            <template #title>
                                <div></div>
                            </template>
                           </gh-code-editor>
                      </v-tab-item>
                      <v-tab>css样式</v-tab>
                      <v-tab-item>
                          <gh-code-editor :height="600" ref="codePage" title="样式编译" :show-actions="false" v-model="currentItem.css"
                          :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'css'}">
                            <template #title>
                                <div></div>
                            </template>
                           </gh-code-editor>
                      </v-tab-item>
                  </v-tabs>
              </v-tab-item>
              <v-tab-item key="后台代码">
                <gh-code-editor :height="600" title="后台代码编辑" :show-actions="false" v-model="currentItem.service"
                  :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'python'}" ref="codeService">
                  <template #title>
                    <div></div>
                  </template>
                </gh-code-editor>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <gh-template-component ref="comp" v-bind="editModeItem" v-show="editMode" />
        </v-layout>
        </v-flex>
    </v-layout>
</v-container>
</template>

<style>
.inline .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}
/*打开时文字位置设置*/
.inline .el-switch__label--right {
  z-index: 1;
  right: -3px;
}
/*关闭时文字位置设置*/
.inline .el-switch__label--left {
  z-index: 1;
  left: 19px;
}
/*显示文字*/
.inline .el-switch__label.is-active {
  display: block;
}
.inline.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 70px !important;
}
</style>

<script>
import PageTemplate from "./pagetemplate.ts";
export default PageTemplate;
</script>